import SubcategoryPage from '@/components/template/SubcategoryPage';

const Irene = () => {
  const products = [
    {
      title: "Irene Model 1",
      imageSrc: "https://images.unsplash.com/photo-1596079890701-dd42edf0b7d4?auto=format&fit=crop&q=80",
      url: "/ogledala/irene/model-1"
    },
    {
      title: "Irene Model 2",
      imageSrc: "https://images.unsplash.com/photo-1616627052149-fe43712e633e?auto=format&fit=crop&q=80",
      url: "/ogledala/irene/model-2"
    },
    {
      title: "Irene Model 3",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/ogledala/irene/model-3"
    },
    {
      title: "Irene Model 4",
      imageSrc: "https://images.unsplash.com/photo-1615800001964-5afd02a82171?auto=format&fit=crop&q=80",
      url: "/ogledala/irene/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Irene"
      description="Elegantna ogledala s klasičnim dizajnom, poimenovana po boginji miru. Njihova umirjena lepota prinaša harmonijo v vsak prostor."
      heroImage="https://images.unsplash.com/photo-1596079890701-dd42edf0b7d4?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Irene;